import {
  Stack,
  MdTimer,
  Typography,
  Box,
  IconButton,
  MdClose,
  Link,
} from '@bymason-private/legacy-pattern-components';
import { ControllerVersion } from '@bymason/controller-api-hooks';
import { useEffect, useMemo, useState } from 'react';
import { useCheckFeatureFlag, useSelectedControllerPref } from '../../global-state';
import { ackBanner, shouldShowBanner } from './utils';

export function LegacyControllerDeprecationBanner() {
  const [isBannerEnabled, bannerDate] = useCheckFeatureFlag('controller-deprecation');

  const handleSwitchToNewController = () => {
    updateSelectedControllerVersion(ControllerVersion.ControllerV2);
  };
  const [, updateSelectedControllerVersion] = useSelectedControllerPref();
  const [timeLeft, setTimeLeft] = useState(0);
  const [isBannerDismissed, setIsBannerDismissed] = useState(false);

  const showBanner = useMemo(() => {
    return !isBannerDismissed && isBannerEnabled && shouldShowBanner() && timeLeft > 0;
  }, [isBannerEnabled, timeLeft, isBannerDismissed]);

  const handleDismissBanner = () => {
    ackBanner();
    setIsBannerDismissed(true);
  };

  useEffect(() => {
    const runDeprecationCountdownBannerFlagCheck = async () => {
      const deprecationDate = new Date(bannerDate);
      if (isBannerEnabled && deprecationDate instanceof Date && !isNaN(deprecationDate.getTime())) {
        const now = new Date();
        const diff = deprecationDate.getTime() - now.getTime();
        if (diff > 0) {
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          setTimeLeft(days);
        }
      }
    };
    runDeprecationCountdownBannerFlagCheck();
  }, [bannerDate, isBannerEnabled]);

  return showBanner ? (
    <Stack
      sx={{
        flexGrow: 1,
        minHeight: '55px',
        backgroundColor: (theme) => theme.palette.primary.dark,
        mb: 0,
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
    >
      <Stack direction='row' alignItems='center' color='white' px={3} py={2} mr={5} gap={1}>
        <Box width={20} height='1.5rem' fontSize={20}>
          <MdTimer />
        </Box>
        <Typography fontWeight='bold'>
          Controller is changing! In
          <Box
            component='span'
            sx={{
              p: 0.5,
              px: 1.2,
              mx: 1,
              borderRadius: 2,
              color: (theme) => (timeLeft < 7 ? theme.palette.error.main : theme.palette.primary.dark),
              backgroundColor: (theme) => theme.palette.common.white,
              width: 'fit-content',
            }}
          >
            {timeLeft} days
          </Box>
          this version will be retired.{' '}
          <Link
            href='https://bymason.zoom.us/rec/play/M7frHb7XjFTdnCY2S3elftcn6-yItuZqppJcSScCUMUuNRVdaLgjmLyp_xU2bjCMJo09SIYm8kL3EXwV.dFTbkwp1DHQKH2dW?canPlayFromShare=true&from=my_recording&continueMode=true&componentName=rec-play&originRequestUrl=https%3A%2F%2Fbymason.zoom.us%2Frec%2Fshare%2FzO9_Lr7ef0JnZf7Fdxqh_ywMNdVMoeDIqW7sZnDtkpcIE6_9O6-F0XD210JAY7Oa.r38oqMPDFw0shspf'
            target='_blank'
            sx={{
              whiteSpace: 'nowrap',
              color: (theme) => theme.palette.warning.dark,
              textDecoration: 'underline',
            }}
          >
            View
          </Link>{' '}
          our recorded training video{` `}
          <Link
            onClick={handleSwitchToNewController}
            sx={{
              whiteSpace: 'nowrap',
              color: (theme) => theme.palette.warning.dark,
              textDecoration: 'underline',
            }}
          >
            Switch to New Controller
          </Link>
        </Typography>
      </Stack>
      <IconButton
        onClick={handleDismissBanner}
        sx={{ color: (theme) => theme.palette.common.white, position: 'absolute', right: '15px' }}
      >
        <MdClose fontSize='20px' />
      </IconButton>
    </Stack>
  ) : null;
}
